export default __webpack_public_path__ + "static/astronauts-a7125413378e7fd8e1c3a8d0c641645d.jpg";